import React from 'react';
import { BookOpenIcon, WrenchScrewdriverIcon, BookmarkIcon, UserGroupIcon } from '@heroicons/react/24/outline';
import PlaybookSection from '../../../components/playbooks/PlaybookSection';
import PlaybookCard from '../../../components/playbooks/PlaybookCard';
import ResourceList from '../../../components/playbooks/ResourceList';

const examples = [
  {
    title: 'PostHog Careers',
    description: 'A great example of transparent and authentic careers page',
    url: 'https://posthog.com/careers'
  },
  {
    title: 'PostHog Handbook',
    description: 'An excellent example of company purpose and values',
    url: 'https://posthog.com/handbook/why-does-posthog-exist'
  },
  {
    title: 'Plain.com Careers',
    description: 'A modern and authentic approach to careers',
    url: 'https://www.plain.com/careers'
  },
  {
    title: 'Attest Careers',
    description: 'A transparent and engaging careers page',
    url: 'https://www.askattest.com/careers/openings'
  },
  {
    title: 'Emerald Group Publishing',
    description: 'A unique and creative approach to careers',
    url: 'https://www.emeraldgrouppublishing.com/start-a-new-chapter-us'
  }
];

const tools = [
  {
    title: 'Open Org Values Evolution Blueprint',
    description: 'A comprehensive guide to evolving your company values alongside your EVP',
    url: 'https://www.notion.so/Open-Org-Values-Evolution-Blueprint-198f015e5d468084be0cdd3f5b1a3980?pvs=21'
  },
  {
    title: 'The Open Job Ad Template',
    description: 'A template for writing authentic, transparent job descriptions',
    url: 'https://www.notion.so/The-Open-Job-Ad-template-cae39c8d51ea4faea9f3f4de962faea0?pvs=21'
  },
  {
    title: 'Careers Site Playbook',
    description: 'A guide to building an authentic careers page',
    url: 'https://www.notion.so/Careers-Site-Playbook-4d59dd1e0cfd496390319915afbe8b8b?pvs=21'
  },
  {
    title: 'The Open Hiring Playbook',
    description: 'A comprehensive guide to transparent hiring practices',
    url: 'https://www.notion.so/The-Open-Hiring-Playbook-432b95fdc47e496aa56239ffe9856426?pvs=21'
  },
  {
    title: '5 Whys Template (Miro)',
    description: 'A template for root cause analysis',
    url: 'https://miro.com/templates/5-whys/'
  },
  {
    title: 'Fishbone Diagram (Miro)',
    description: 'A template for cause and effect analysis',
    url: 'https://miro.com/templates/fishbone-diagram/'
  },
  {
    title: 'Give & Get: Employer Branding for Belonging',
    description: 'A book on building authentic employer brands',
    url: 'https://www.amazon.co.uk/Give-Get-Employer-Branding-Belonging-ebook/dp/B084ZCJWTJ'
  },
  {
    title: 'Sazzle - Survey Results Analyzer',
    description: 'Your GPT survey results Analyzer! 🔥',
    url: 'https://www.openverse.fyi/resource/sazzle-the-survey-results-analyser'
  }
];

const people = [
  {
    title: 'Vanessa Monsequeira',
    description: 'People Leader building in public',
    url: 'https://www.linkedin.com/in/vanessamonsequeira/'
  },
  {
    title: 'Frieda Möcker',
    description: 'People Leader building in public',
    url: 'https://www.linkedin.com/in/friederikemoecker/'
  },
  {
    title: 'Dajana Berisavljević Đakonović',
    description: 'People Leader building in public',
    url: 'https://www.linkedin.com/in/dajana-berisavljevic/'
  },
  {
    title: 'Eva Spexard',
    description: 'People Leader building in public',
    url: 'https://www.linkedin.com/in/evaspexard/'
  }
];

const EmployerBrandUsefulResources = () => (
  <div className="space-y-8">
    <PlaybookSection title="Useful Resources" icon={<BookOpenIcon className="h-7 w-7 text-primary-light" />} heading>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <PlaybookCard>
          <ResourceList 
            title="Examples We Love" 
            items={examples} 
            icon={BookOpenIcon}
          />
        </PlaybookCard>
        <PlaybookCard>
          <ResourceList 
            title="Tools & Templates" 
            items={tools} 
            icon={WrenchScrewdriverIcon}
          />
        </PlaybookCard>
        <PlaybookCard className="md:col-span-2">
          <ResourceList 
            title="Inspiring People Leaders" 
            items={people} 
            icon={UserGroupIcon}
          />
        </PlaybookCard>
      </div>
    </PlaybookSection>
  </div>
);

export default EmployerBrandUsefulResources; 